import React  from "react";
import { Link } from "react-router-dom";
import Logo from "~/assets/images/logo/logo-text-right-color.png";

const BackBar = ({path, showLogo})=> {

  const goBack = ()=> {
    document.body.style.overflow = "auto";
  };

  return (
    <div style={{position: 'relative', minHeight: 40}}>
      {showLogo && <div className="text-center p-10">
        <img src={Logo} style={{ maxWidth : 100 }} />
      </div> }

      <div className="float-right p-10" style={{position: 'absolute', right: 0, top: 0}} onClick={goBack}>
        <Link to={path} className="text-muted" style={{cursor:'pointer'}}> &lt; Back to app</Link>
      </div>

    </div>
  );
};

export default BackBar;
